<script setup lang="ts">
	import {computed} from 'vue';
	
	const props = defineProps({
		//id: String,
		value: String,
		style: String,
		styleClass: String
	});
	
	const hasValue = computed(() => {
		return props.value !== null && props.value !== undefined;
	});
	
</script>
<template> 
	<td v-if="hasValue" :class="styleClass" :style="style" v-html="value"></td>
	<td v-else :class="styleClass" :style="style" >&nbsp;</td>
</template> 
